import React from "react"
import { useFormikContext } from "formik"

import IntlTelInput from "react-intl-tel-input"
import "react-intl-tel-input/dist/main.css"

import FormError from "../../../formError"

const OtherInfo = () => {
  const {
    values,
    errors,
    touched,
    handleChange,
    setFieldValue,
  } = useFormikContext()

  return (
    <div className="form-row justify-content-center">
      <div className="form-group col-md-6">
        <label htmlFor="new_email">New Email Address</label>
        <input
          type="text"
          className="form-control"
          id="new_email"
          name="new_email"
          onChange={handleChange}
          value={values.new_email}
        />

        <FormError touched={touched.new_email} message={errors.new_email} />
      </div>

      <div className="form-group col-md-6">
        <label htmlFor="new_phone">New Phone Number</label>
        <IntlTelInput
          inputClassName="form-control"
          defaultCountry="ng"
          id="new_phone"
          fieldName="new_phone"
          autoComplete="tel"
          onPhoneNumberChange={(fullnumber, newNumber) => {
            setFieldValue("new_phone", newNumber)
          }}
          value={values.new_phone}
          placeholder="080X XXXX XXX"
        />

        <FormError touched={touched.new_phone} message={errors.new_phone} />
      </div>
    </div>
  )
}

export default OtherInfo
